import {React, useEffect, useState, useRef} from 'react'
import { CSVLink } from "react-csv"
import axios from 'axios'
import '../App.css';
import DownloadButton from '../controls/DownloadButton';
import LoadingControl from './Loading';
import SearchTable from './SearchTable'
import {ApplyFilterParams} from '../utils/ApplyFilterParams'

const DetailedReport = (props) => {

    const layout = {
        bordered : true,
        showSizeChanger : true, 
        pagination : {pageSize: 50, showSizeChanger: false},
        size: "small",
        rowKey : record => record.id,
    };

    let csvLink = useRef(null);
  
    const [state, setState] = useState({
        error: null,
        isLoaded: false,
        data: null,
        csvData: [],
     });

     async function getData() {       
        var url = ApplyFilterParams(props.api_url, props.filterData);
        const res = await axios(url);
        return res.data;
        }

    function calcWorkload(data) {
        if (!(data instanceof Array)) {
            return [];
        } 
        
        let totalPages = 0;
        let filter_data = data.filter(rec => rec.documents > 0).map(rec => {
            totalPages += rec.pages;
            return rec;
            }
        );

        return filter_data.map(rec =>  {
            rec.workload = (rec.pages / totalPages) * 100;
            return rec;
        });
    }

    function update() {
        setState({...state, isLoaded: false});
    
        getData()
        .then(res => {
            setState({...state,  error: null, isLoaded: true, data: props.useWorkload ? calcWorkload(res) : res});
        })
        .catch(err => {
            console.log(err);
            setState({...state, error: err, isLoaded: false, data: null});
        });
        }  

    const prevStateCVS = usePrevious(state.csvData);

    function usePrevious(value) {
        const ref = useRef();
        useEffect(() => {
            ref.current = value;
        }, [value]);
        return ref.current;
        }
    
    useEffect(() => {
        if (!csvLink.current || prevStateCVS === state.csvData)
        {
            update();
        }
        else
        {
            csvLink.current.link.click();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [state.csvData, props.api_url, props.filterData]);

    function onCSVExportClick()
    {
      setState({...state, csvData: state.data });
    }

    if(state.error != null)
    {
        return (
            <div>
                <h3>{state.error.message}</h3>
            </div>
        );
    }
    else if (!state.isLoaded)
    {
        return (
            <div className = "style-center"><LoadingControl/></div>
        );
    }
    else
    {      
        return (       
            <div className = "history-pane-header">
                <div className = "range-picker">&#8202;</div>
                <CSVLink 
                data={state.csvData}
                separator=";"
                ref={(r) => csvLink.current = r}
                filename="data.csv"
                className="hidden"
                target="_blank">                
                </CSVLink>
                <DownloadButton onCSVExport = {() => {onCSVExportClick()}}/> 
                <div className = "report-table">
                    <SearchTable
                        layout = {layout}
                        type = {undefined}
                        columns={props.columns} 
                        dataSource={state.data} 
                    />
                </div>
            </div>
            );
    }
}

export default DetailedReport;